var FunderAPI = require("../../common/api/funder");
var SchemeAPI = require("../../common/api/scheme");
var ApplicationAPI = require("../../common/api/application");
var ApplicantAPI = require("../../common/api/applicant");
var MessageAPI = require("../../common/api/messages");
var auth = require('../../common/auth')
var Promise = require("bluebird");
var _ = require("underscore");
var moment = require("moment");
var enums = require('../../common/enums');

module.exports = function ($scope, $stateParams, ngDialog, $rootScope, $window, $location) {

    $scope.funderId = null;

    $scope.isApplicant = auth.hasClaims([{ type: "user_role", value: "applicant" }]);
    $scope.applicantId = auth.getClaimValue("ApplicantAdmin");

    $scope.isFunder = auth.hasClaims([{ type: "user_role", value: "funder" }]);
    $scope.myFunderId = auth.getClaimValue("FunderMember");
    $scope.hasActiveConversation = false;
    $scope.isDifferentFunder = false;
    $scope.conversationId = false;



    $scope.OrganisationManagementType = enums.OrganisationManagementType;
    $scope.OrganisationType = enums.OrganisationType;
    $scope.SupportedProjects = enums.SupportedProjects;
    $scope.isMsgOpen = false;

    var dialogs = {
        gallery: {
            template: require("./dialogs/gallery.pug")(),
            controller: require("./dialogs/gallery")
        },
        video: {
            template: require("./dialogs/galleryVideo.pug")(),
            controller: require("./dialogs/galleryVideo")
        }
    };


    $scope.getDescription = function (enm, id) {
        for (var i = 0; i < enm.length; i++) {
            var item = enm[i];
            if (item.id == id) return item.description;
        }
    };

    $scope.init = function () {
        $scope.loading = true;
        FunderAPI.GetByFunderRef($stateParams.funderRef).then(function (result) {
            $scope.funderId = result.id;
            var p1 = FunderAPI.GetFunder($scope.funderId, "PublicFunderDetailsView").then(function (result) {
                $scope.loading = false;
                $scope.funder = result;
                $scope.funder.funderRef = $stateParams.funderRef;
                if ($scope.funder.logo) {
                    var formattedId = ($scope.funder.logo.blobId).replace(/-/g, '');
                    $scope.funder.logo.url = encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent(formattedId) + "/" + $scope.funder.logo.fileName)
                }
            });

            var p2 = FunderAPI.GetSchemes($scope.funderId, false, true, 1, null, "FunderSchemesPublicView").then(function (results) {
                $scope.schemes = results;
            });

            var p3 = FunderAPI.GetSupportedApplications($scope.funderId).then(function (results) {
                $scope.supportedApplications = results.results;
                $scope.supportedApplications.forEach(function (app) {
                    app.percentage = 0;
                    if (!app.grandTotalRaised && !app.totalRequested && !app.totalExternallyRaised) {
                        return;
                    }

                    app.percentage = Math.floor((app.grandTotalRaised / (app.totalRequested + app.totalExternallyRaised)) * 100);
                    if (app.percentage > 100) {
                        app.percentage = 100;
                    }
                });
            });

            var p4 = checkFunderHasConversation();

            return Promise.all([p1, p2, p3, p4]);

        });
    };

    $scope.downloadAccount = function () {
        if ($scope.funder.account) {
            var formattedId = ($scope.funder.account.blobId).replace(/-/g, '');
            $scope.funder.account.downloadUrl = window.conf.doc_repos_url + "get/"
                + encodeURIComponent(formattedId) + "/"
                + $scope.funder.account.fileName;

            //download file here (use default window behaviour)
            $window.location.href = $scope.funder.account.downloadUrl;
        }
    };

    $scope.downloadReport = function () {
        if ($scope.funder.report) {
            var formattedId = ($scope.funder.report.blobId).replace(/-/g, '');
            $scope.funder.report.downloadUrl = window.conf.doc_repos_url + "get/"
                + encodeURIComponent(formattedId) + "/"
                + $scope.funder.report.fileName;

            //download file here (use default window behaviour)
            $window.location.href = $scope.funder.report.downloadUrl;
        }
    };

    $scope.submitDescription = function (request) {
        var publicDescription = request.publicDescription;
        if (publicDescription) {
            $scope.funder.publicDescription = publicDescription;
            FunderAPI.UpdatePublicDescription($scope.funderId, publicDescription).then(function () { });
        }
    };

    $scope.submitSchemeDescription = function (request, scheme) {
        if (request.publicDescription) {
            scheme.publicDescription = request.publicDescription;
            SchemeAPI.PublicDescriptionUpdate(scheme.id, request.publicDescription).then(function () { });
        }
    };

    /*GALLERY IMAGES*/

    var openGalleryDialog = function (item, dialogName) {
        if (!dialogName)
            dialogName = "gallery";
        var template = dialogs[dialogName].template;
        var controller = dialogs[dialogName].controller;
        var dialog = ngDialog.open({
            template: template,
            controller: controller,
            plain: true,
            closeByDocument: false,
            disableAnimation: true,
            resolve: {
                item: function () {
                    return item;
                }
            }
        });
        return dialog;
    };

    $scope.toggle = function (toggleName) {
        if (toggleName == 'isConOpen') {
            $scope.isConOpen = !$scope.isConOpen;
        } else if (toggleName == 'isFinOpen') {
            $scope.isFinOpen = !$scope.isFinOpen;
        } else {
            $scope.isOrgOpen = !$scope.isOrgOpen;
        }
    };

    $scope.addGalleryItem = function () {
        var item = {};
        var dialog = openGalleryDialog(item, "gallery");

        dialog.closePromise.then(function (data) {
            var item = data.value.item;
            if (item) {
                $scope.funder.funderGalleryItems.push(item);
                FunderAPI.AddGalleryItem($scope.funderId, item).then(function (result) {
                    item.id = result;
                });
            }
        });
    };

    $scope.addGalleryVideo = function () {
        var item = {};
        var dialog = openGalleryDialog(item, "video");

        dialog.closePromise.then(function (data) {
            var item = data.value.item;
            if (item) {
                $scope.funder.funderGalleryItems.push(item);
                FunderAPI.AddGalleryItem($scope.funderId, item).then(function (result) {
                    item.id = result;
                });
            }
        });
    };

    $scope.editGalleryItem = function (item, event) {
        event.preventDefault();
        event.stopPropagation();
        var modalType = "gallery";
        if (item.isVideo)
            modalType = "video";
        var dialog = openGalleryDialog(_.clone(item), modalType);
        dialog.closePromise.then(function (data) {
            var item = data.value.item;
            if (item) {
                item.createdDate = moment().format("YYYY-MM-DDThh:mm:ss");
                _.extend(_.findWhere($scope.funder.funderGalleryItems, { id: item.id }), item);
                FunderAPI.UpdateGalleryItem($scope.funderId, item.id, item).then(function (result) {
                    item.id = result;
                });
            }
        });
    };

    $scope.deleteGalleryItem = function (item, event) {
        event.preventDefault();
        event.stopPropagation();
        var promise = ngDialog.openConfirm({
            template: "\
                <p>Are you sure you want to delete this image?</p>\
                <div class=\"ngdialog-buttons clearfix\">\
                    <button type=\"button\" class=\"btn btn-green btn-sm pull-xs-right m-l-1\" ng-click=\"closeThisDialog(0)\">No</button>\
                    <button type=\"button\" class=\"btn btn-danger btn-sm pull-xs-right\" ng-click=\"confirm(1)\">Yes</button>\
                </div>",
            plain: true,
            disableAnimation: true
        });
        promise.then(function () {
            FunderAPI.DeleteGalleryItem($scope.funderId, item.id).then(function () {
                $scope.funder.funderGalleryItems = _.without($scope.funder.funderGalleryItems, _.findWhere($scope.funder.funderGalleryItems, { id: item.id }));
            });
        });
    };

    var openApplyDialog = function (funderId, schemeId) {
        var dialog = ngDialog.open({
            template: require("./dialogs/begin-application.pug")(),
            controller: require("./dialogs/begin-application"),
            controllerAs: 'vm',
            plain: true,
            closeByDocument: false,
            data: {
                existingApplicationId: $location.search().fromApplication,
                funderId: funderId,
                schemeId: schemeId
            }
        });
        return dialog;
    };

    var openDirectSubmittedDialog = function (applicationId) {
        var dialog = ngDialog.open({
            template: require("./dialogs/direct-submitted.pug")(),
            controller: require("./dialogs/direct-submitted"),
            controllerAs: 'vm',
            plain: true,
            closeByDocument: false,
            data: {
                applicationId: applicationId
            }
        });
        dialog.closePromise.then(function (data) {
            var dialogForm = data.value;
            if (!dialogForm || dialogForm.action != 'ok') return;
            $window.location.href = "/applicant/dashboard/projects/" + encodeURIComponent(applicationId);
        });
        return dialog;
    };

    $scope.applyForFunding = function (funder, scheme) {
        if ($scope.applicantId != null) {
            var dialog = openApplyDialog(funder.id, scheme && scheme.id);
            dialog.closePromise.then(function (data) {
                var dialogForm = data.value;
                if (!dialogForm || dialogForm.action != 'ok') return;

                var funderId = funder.id;
                var schemeId = scheme ? scheme.id : null;

                if (dialogForm.newApplication) {
                    // new application
                    var projectTitle = dialogForm.projectTitle;
                    var seekingPublicFunding = dialogForm.seekingPublicFunding;
                    var seekingTrustFunding = true;
                    ApplicationAPI.Begin($scope.applicantId, projectTitle, seekingPublicFunding, seekingTrustFunding, funderId, schemeId).then(function (resp) {
                        $window.location.href = "/applicant/application/" + encodeURIComponent(resp);
                    });
                } else {
                    // existing application
                    var appId = dialogForm.existingApplicationId;
                    ApplicationAPI.SubmitApplicationDirect(appId, funderId, schemeId).then(function (resp) {
                        openDirectSubmittedDialog(appId);
                    }, function (resp) {
                        alert('There was a problem submitting your application.  Please try again later or contact support.');
                    });
                }

            });
        } else {
            $window.location.href = "/applicant-registration";
        }
    };

    var checkFunderHasConversation = function () {
        if ($scope.myFunderId != $scope.funderId && $scope.isFunder) {
            $scope.isDifferentFunder = true;
            getFunderConversation();
        }
    };

    $scope.contactFunder = function () {
        if ($scope.isDifferentFunder && !$scope.hasActiveConversation) {
            MessageAPI.StartNewFunderConversation($scope.myFunderId, $scope.funderId).then(function () {
                getFunderConversation();
            });
        }
    };

    var getFunderConversation = function () {
        MessageAPI.GetFunderFunderConversation($scope.myFunderId, $scope.funderId).then(function (results) {
            if (results.conversationId && results.conversationId != "" && results.conversationId != "00000000-0000-0000-0000-000000000000") {
                $scope.hasActiveConversation = true;
                $scope.conversationId = results.conversationId;
                $scope.isMsgOpen = true;
            }
        });
    };

    $scope.toggleIsMsgOpen = function () {
        $scope.isMsgOpen = !$scope.isMsgOpen;
    };

    $scope.getApplicationPopup = function () {
        return "Apply once for " + $scope.funder.name + " and other registered funders on The Good Exchange.";
    };

    $scope.init();
};
